import React from 'react';
import {createRoot} from 'react-dom/client';
import Animations from './js/animations.js';

import CarierForm from './components/carier-form.js';
import Survey from "./components/Survey";
import DemandForm from "./components/DemandForm";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

function validateEmail(email) {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) +
        ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
}

document.addEventListener("DOMContentLoaded", function (event) {
        let doc = document;
        let width = doc.documentElement.clientWidth;

        let header = doc.querySelector('header');

        window.onload = function () {
            doc.getElementsByTagName('body')[0].classList.add('loaded');

            imgComparator();
            carousel();
        }

        new LazyLoad({
            elements_selector: '.lazy',
        });


        const videoStories = doc.querySelector('.our-stories video');
        if (videoStories) {
            videoStories.play();
        }

        const carierFormElement = doc.getElementById('carier-form');
        if (carierFormElement) {
            const root = createRoot(carierFormElement)
            root.render(
                <GoogleReCaptchaProvider reCaptchaKey="6LdwhU0oAAAAAOEYfCjZlkJ5iWtRttasHYtZPicN">
                    <CarierForm id={carierFormElement.getAttribute('data-id-career')}/>
                </GoogleReCaptchaProvider>
            );
        }

        /*    const instagram = doc.getElementById('instagram-feed');
            if (instagram) {
                const root = createRoot(instagram)
                root.render(<Instagram />);
            }*/

        const demandFormElement = doc.getElementById('demand-form');
        if (demandFormElement) {
            const root = createRoot(demandFormElement)
            root.render(
                <GoogleReCaptchaProvider reCaptchaKey="6LdwhU0oAAAAAOEYfCjZlkJ5iWtRttasHYtZPicN">
                    <DemandForm/>
                </GoogleReCaptchaProvider>
            );
        }

        const surveyE = doc.getElementById('survey');
        if (surveyE) {
            const root = createRoot(surveyE);
            root.render(<Survey/>);
        }

        const hamburger = doc.querySelector('.hamburger');
        if (hamburger) {
            hamburger.addEventListener('click', () => {
                header.classList.toggle('open-menu');
            });
        }

        let slider = doc.querySelector('.slider ul');
        let sliderBg = doc.querySelector('.slider-background');
        if (slider) {
            let butRightSlider = doc.querySelectorAll('.slider button.right');
            let butLeftSlider = doc.querySelectorAll('.slider button.left');
            let slideItem = doc.querySelectorAll('.slider li');
            let itemWidth = slideItem[0].clientWidth;
            let i = 1;

            butRightSlider.forEach((e) => {
                e.addEventListener('click', function () {
                    if (i < slideItem.length) {
                        let actMargin = parseInt(slider.style.marginLeft, 10) || 0;
                        slider.style.marginLeft = actMargin - itemWidth + 'px';
                        butLeftSlider.forEach((a) => {
                            a.classList.remove('disable');
                        });
                        i++;
                        if (i === slideItem.length) {
                            butRightSlider.forEach((a) => {
                                a.classList.add('disable');
                            });
                        }
                    }
                })
            });
            butLeftSlider.forEach((e) => {
                e.addEventListener('click', function () {
                    if (i > 1) {
                        let actMargin = parseInt(slider.style.marginLeft, 10) || 0;
                        slider.style.marginLeft = actMargin + itemWidth + 'px';
                        i--;
                        if (i === 1) {
                            butLeftSlider.forEach((a) => {
                                a.classList.add('disable');
                            });
                        }
                        if (i < slideItem.length) {
                            butRightSlider.forEach((a) => {
                                a.classList.remove('disable');
                            });
                        }
                    }
                })
            });
        } else if (sliderBg) {
            let butRightSlider = document.querySelectorAll('.slider button.right');
            let butLeftSlider = document.querySelectorAll('.slider button.left');
            let slideImageElement = document.querySelector('.slider .image');
            let position = 0;
            let maxPosition = slideImageElement.getAttribute('data-width-image') - width;

            butRightSlider.forEach((e) => {
                e.addEventListener('click', function () {
                    position = parseInt(position - width / 3, 10);
                    if (maxPosition < position * -1) {
                        position = maxPosition * -1;
                    }

                    if (parseInt(slideImageElement.style.backgroundPosition.split(' ')[0], 10) * -1 >= maxPosition) {
                        position = 0;
                    }

                    slideImageElement.style.backgroundPosition = position + 'px center';

                })
            });
            butLeftSlider.forEach((e) => {
                e.addEventListener('click', function () {
                    position = parseInt(position + width / 3, 10);
                    if (position > 0) {
                        if (position === parseInt(width / 3, 10)) {
                            position = maxPosition * -1;
                        } else {
                            position = 0;
                        }
                    }
                    slideImageElement.style.backgroundPosition = position + 'px center';
                })
            });
        }


        let redosSlider = document.querySelector('.redos-slider ul');
        if (redosSlider) {

            let coef = 0.02;
            if (width <= 575) {
                coef = 0.0;
            }
            let leftButton = document.querySelector('.redos-slider .left');
            let rightButton = document.querySelector('.redos-slider .right');

            let item = redosSlider.querySelector('li');
            let widthItem = item.clientWidth + redosSlider.clientWidth * coef;
            let totalW = widthItem * redosSlider.querySelectorAll('li').length;

            rightButton.addEventListener('click', function () {

                let actMargin = parseFloat(redosSlider.style.marginLeft) || 0;
                let newPosition = actMargin + widthItem * -1;


                if (newPosition * (-1) <= totalW - redosSlider.clientWidth) {
                    redosSlider.style.marginLeft = newPosition + 'px';
                    leftButton.classList.remove('disabled');
                }
                if (coef !== 0) {
                    actMargin = parseFloat(redosSlider.style.marginLeft) || 0;
                    newPosition = actMargin + widthItem * -1;
                }

                if (newPosition <= (totalW - redosSlider.clientWidth) * (-1) + redosSlider.clientWidth * coef) {
                    leftButton.classList.remove('disabled');
                    rightButton.classList.add('disabled');
                }
            });

            leftButton.addEventListener('click', function () {
                let widthItem = redosSlider.querySelector('li').clientWidth + redosSlider.clientWidth * coef;
                let actMargin = parseFloat(redosSlider.style.marginLeft) || 0;
                if (actMargin * -1 > 0) {
                    redosSlider.style.marginLeft = actMargin - widthItem * -1 + 'px';
                    rightButton.classList.remove('disabled');
                }
                actMargin = parseFloat(redosSlider.style.marginLeft) || 0;

                if (actMargin * -1 === 0) {
                    leftButton.classList.add('disabled');
                }
            });
        }
        let profirolIcons = doc.querySelectorAll('.controllers .icon');
        for (let i = 0; i < profirolIcons.length; i++) {
            let pc_id = profirolIcons[i].getAttribute('data-value');
            let static_img = '/images/profirol/controlers/c' + pc_id + '.png';
            let ani_img = '/images/profirol/controlers/c' + pc_id + '.gif';

            profirolIcons[i].addEventListener('mouseover', () => {
                profirolIcons[i].querySelector('img').setAttribute('src', ani_img);
            });

            profirolIcons[i].addEventListener('mouseout', () => {
                profirolIcons[i].querySelector('img').setAttribute('src', static_img);
            });

        }
        let bF = doc.getElementById('blog-form');
        if (bF) {
            bF.addEventListener('submit', (e) => {
                e.preventDefault();
                let valid = true;
                let errors = bF.querySelectorAll('.error');
                if (errors.length > 0) {
                    for (let i = 0; i < errors.length; i++) {
                        errors[i].classList.remove('error');
                    }
                }

                if (window.grecaptcha === undefined) {
                    return;
                }

                window.grecaptcha.ready(async function () {
                    window.grecaptcha.execute('6LdwhU0oAAAAAOEYfCjZlkJ5iWtRttasHYtZPicN', {action: 'submit'}).then((token) => {

                        const name = bF.querySelector('input[name="name"]');
                        const email = bF.querySelector('input[name="email"]');
                        const phone = bF.querySelector('input[name="phone"]');

                        if (!name.value) {
                            name.classList.add('error');
                            valid = false;
                        }
                        if (!email.value || !validateEmail(email.value)) {
                            email.classList.add('error');
                            valid = false;
                        }
                        if (!phone.value) {
                            phone.classList.add('error');
                            valid = false;
                        }


                        if (valid) {
                            let formData = new FormData(bF);
                            formData.append('captcha', token);

                            bF.querySelector('button').disabled = true;
                            fetch('/ajax/send-contact-form.php', {
                                method: 'POST',
                                body: formData
                            })
                                .then(response => response.json())
                                .then((response) => {
                                    const msg = response.msg;
                                    const code = response.code;
                                    if (code === 1) {
                                        window.dataLayer = window.dataLayer || []
                                        window.dataLayer.push({
                                            'event': 'formSubmission'
                                        });

                                        bF.classList.add('animated');
                                        bF.classList.add('fadeOut');

                                        doc.querySelector('.blog-form h3').classList.remove('fadeOut');
                                        bF.classList.remove('fadeIn');

                                        doc.querySelector('.blog-form h3').classList.add('animated');
                                        doc.querySelector('.blog-form h3').classList.add('fadeIn');

                                        bF.querySelector('button').disabled = false;
                                        bF.reset();


                                        setTimeout(() => {
                                            doc.querySelector('.blog-form h3').classList.remove('fadeIn');
                                            doc.querySelector('.blog-form h3').classList.add('fadeOut');
                                        }, 3500);
                                        setTimeout(() => {
                                            bF.classList.remove('fadeOut');
                                            bF.classList.add('fadeIn');
                                        }, 4500);
                                    } else {
                                        cF.querySelector('button').disabled = false;
                                        alert(msg);
                                    }

                                })
                                .catch(error => console.error('Error:', error));
                        }
                    });
                });
            });
        }


        let lpF = doc.getElementById('lp-form');
        if (lpF) {
            lpF.addEventListener('submit', (e) => {
                let valid = true;
                let errors = lpF.querySelectorAll('.error');
                if (errors.length > 0) {
                    for (let i = 0; i < errors.length; i++) {
                        errors[i].classList.remove('error');
                    }
                }

                if (window.grecaptcha === undefined) {
                    return;
                }

                window.grecaptcha.ready(async function () {
                    window.grecaptcha.execute('6LdwhU0oAAAAAOEYfCjZlkJ5iWtRttasHYtZPicN', {action: 'submit'}).then((token) => {
                        const name = lpF.querySelector('input[name="name"]');
                        const email = lpF.querySelector('input[name="email"]');
                        const phone = lpF.querySelector('input[name="phone"]');
                        const gdpr = lpF.querySelector('input[name="gdpr"]');

                        if (!name.value) {
                            name.classList.add('error');
                            valid = false;
                        }
                        if (!email.value || !validateEmail(email.value)) {
                            email.classList.add('error');
                            valid = false;
                        }
                        if (!phone.value) {
                            phone.classList.add('error');
                            valid = false;
                        }

                        if (gdpr.checked === false) {
                            lpF.querySelector('label[for="gdpr-input"]').classList.add('error');
                            valid = false;
                        }


                        if (valid) {
                            let formData = new FormData(lpF);
                            formData.append('captcha', token);
                            formData.append('lp', 1);
                            lpF.querySelector('button').disabled = true;
                            fetch('/ajax/send-contact-form.php', {
                                method: 'POST',
                                body: formData
                            })
                                .then(response => response.json())
                                .then((response) => {

                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'formSubmission'
                                    });

                                    lpF.classList.add('animated');
                                    lpF.classList.add('fadeOut');

                                    doc.querySelector('.lp .form h3').classList.remove('fadeOut');
                                    lpF.classList.remove('fadeIn');

                                    doc.querySelector('.lp .form h3').classList.add('animated');
                                    doc.querySelector('.lp .form h3').classList.add('fadeIn');

                                    lpF.querySelector('button').disabled = false;
                                    lpF.reset();


                                    setTimeout(() => {
                                        doc.querySelector('.lp .form h3').classList.remove('fadeIn');
                                        doc.querySelector('.lp .form h3').classList.add('fadeOut');
                                    }, 3500);
                                    setTimeout(() => {
                                        lpF.classList.remove('fadeOut');
                                        lpF.classList.add('fadeIn');
                                    }, 4500);


                                })
                                .catch(error => console.error('Error:', error));
                        }
                    })
                });
            });
        }

        let contactForm = doc.querySelector('.contact-form');
        if (contactForm) {
            let contactFormButton = doc.querySelector('.our-stories button');
            let closeContactForm = contactForm.querySelector('.close');
            let body = doc.querySelector('body');
            let html = doc.querySelector('html');
            let cFModal = doc.querySelector('.contact-form');

            closeContactForm.addEventListener('click', () => {
                body.classList.remove('open-contact-form');
                html.removeAttribute('style');
            });
            if (contactFormButton) {
                contactFormButton.addEventListener('click', () => {
                    body.classList.add('open-contact-form');
                    html.style.overflow = 'hidden';
                });
            }

            let cF = doc.getElementById('contact-form');
            if (cF) {
                cF.addEventListener('submit', async (e) => {
                    e.preventDefault();
                    let valid = true;
                    let errors = cF.querySelectorAll('.error');
                    if (errors.length > 0) {
                        for (let i = 0; i < errors.length; i++) {
                            errors[i].classList.remove('error');
                        }
                    }

                    if (window.grecaptcha === undefined) {
                        return;
                    }

                    window.grecaptcha.ready(async function () {
                        window.grecaptcha.execute('6LdwhU0oAAAAAOEYfCjZlkJ5iWtRttasHYtZPicN', {action: 'submit'}).then((token) => {
                            const name = cF.querySelector('input[name="name"]');
                            const email = cF.querySelector('input[name="email"]');
                            const phone = cF.querySelector('input[name="phone"]');
                            const variant = cF.querySelector('input[name="variant"]');
                            //let checkbox = cF.querySelector('.checkbox');

                            if (!name.value) {
                                name.classList.add('error');
                                valid = false;
                            }
                            if (!email.value || !validateEmail(email.value)) {
                                email.classList.add('error');
                                valid = false;
                            }
                            if (!phone.value) {
                                phone.classList.add('error');
                                valid = false;
                            }
                            /*if (!checkbox.querySelector('input[type="checkbox"]').checked) {
                                checkbox.classList.add('error');
                                valid = false;
                            }*/

                            if (valid) {
                                const formData = new FormData(cF);
                                formData.append('captcha', token);

                                cF.querySelector('button').disabled = true;
                                fetch('/ajax/send-contact-form.php', {
                                    method: 'POST',
                                    body: formData
                                })
                                    .then(response => response.json())
                                    .then((response) => {
                                        const msg = response.msg;
                                        const code = response.code;
                                        if (code === 1) {

                                            window.dataLayer = window.dataLayer || []
                                            window.dataLayer.push({
                                                'event': 'formSubmission',
                                                'variant': variant?.value
                                            });

                                            cFModal.querySelector('.container').classList.add('animated');
                                            cFModal.querySelector('.container').classList.add('fadeOut');

                                            cFModal.querySelector('h3').classList.add('animated');
                                            cFModal.querySelector('h3').classList.add('fadeIn');
                                            cF.querySelector('button').disabled = false;
                                            cF.reset();

                                            setTimeout(() => {
                                                body.classList.remove('open-contact-form');
                                                html.removeAttribute('style');

                                                cFModal.querySelector('h3').classList.remove('animated');
                                                cFModal.querySelector('h3').classList.remove('fadeIn');
                                            }, 3500);
                                            setTimeout(() => {
                                                cFModal.querySelector('.container').classList.remove('animated');
                                                cFModal.querySelector('.container').classList.remove('fadeOut');
                                            }, 4500);
                                        } else {
                                            cF.querySelector('button').disabled = false;
                                            alert(msg);
                                        }
                                    }).catch(error => console.error('Error:', error));
                            }
                        })
                    });
                })
            }
        }

        let cookiesBanner = document.querySelector('#cookies-banner');
        if (cookiesBanner) {
            let buttonCookies = document.querySelector('#cookies-banner button');
            buttonCookies.addEventListener('click', () => {
                cookiesBanner.classList.add('slideOutDown');
                setCookie('cookies_hide', 1, 365);
                setTimeout(() => {
                    cookiesBanner.parentNode.removeChild(cookiesBanner);
                }, 1200)
            })
        }


    }
)
;


// Let's use this function
function scrollIt(x, item) {
    let transform = Math.max(
        0,
        Math.min(x, item.querySelector(".wrapper").offsetWidth)
    );
    item.querySelector(".after").style.width = transform + "px";
    item.querySelector(".scroller").style.left = transform + "px";
}

function calcHeight(item) {
    const width = item.offsetWidth;
    const ratio = item.getAttribute("data-ratio");

    item.querySelector(".wrapper").style.height = width / parseFloat(ratio) + "px";
}

function imgComparator() {
    let imgComparator = document.querySelectorAll(".img-comparator");

    if (imgComparator.length > 0) {
        imgComparator.forEach((item) => {
            let active = false;
            calcHeight(item);
            let scroller = item.querySelector(".scroller");
            // First we'll have to set up our event listeners
            // We want to watch for clicks on our scroller
            scroller.addEventListener("mousedown", function () {
                active = true;
                // Add our scrolling class so the scroller has full opacity while active
                scroller.classList.add("scrolling");
            });
            // We also want to watch the body for changes to the state,
            // like moving around and releasing the click
            // so let's set up our event listeners
            document.body.addEventListener("mouseup", function () {
                active = false;
                scroller.classList.remove("scrolling");
            });
            document.body.addEventListener("mouseleave", function () {
                active = false;
                scroller.classList.remove("scrolling");
            });

            // Let's figure out where their mouse is at
            document.body.addEventListener("mousemove", function (e) {
                if (!active) return;
                // Their mouse is here...
                let x = e.pageX;
                // but we want it relative to our wrapper
                x -= item.querySelector(".wrapper").getBoundingClientRect().left;
                // Okay let's change our state
                scrollIt(x, item);
            });

            item.querySelector(".after").style.backgroundSize =
                item.querySelector(".wrapper").clientWidth + "px 100%";
            item.querySelector(".before").style.backgroundSize =
                item.querySelector(".wrapper").clientWidth + "px 100%";

            // Let's set our opening state based off the width,
            // we want to show a bit of both images so the user can see what's going on
            scrollIt(item.querySelector(".wrapper").clientWidth / 2, item);

            // And finally let's repeat the process for touch events
            // first our middle scroller...
            scroller.addEventListener("touchstart", function () {
                active = true;
                scroller.classList.add("scrolling");
            });

            document.body.addEventListener("touchend", function () {
                active = false;
                scroller.classList.remove("scrolling");
            });
            document.body.addEventListener("touchmove", function (e) {
                if (!active) return;
                // Their mouse is here...
                let x = e.touches[0].pageX;
                // but we want it relative to our wrapper
                x -= item.querySelector(".wrapper").getBoundingClientRect().left;
                // Okay let's change our state
                scrollIt(x, item);
            });
            document.body.addEventListener("touchcancel", function () {
                active = false;
                scroller.classList.remove("scrolling");
            });
            window.addEventListener("resize", function () {
                calcHeight(item);
            });
        });
    }
}

let slides = "";
let first_slide = "";
let second_slide = "";
let third_slide = "";
let slide_size = "";
let slide_parent = "";

function carousel() {
    window.slide_parent = document.querySelector(".cards-carousel");
    if (window.slide_parent) {
        window.slides = window.slide_parent.querySelector(".w-100.flex").children;
        slideHeight();

        if (
            document.readyState === "complete" ||
            document.readyState === "interactive"
        ) {
            setTimeout(() => {
            }, 100);
        }

        recalculateMoveDistance();

        document.addEventListener("swiped-right", () => {
            moveLeft();
        });
        document.addEventListener("swiped-left", () => {
            moveRight();
        });

        window.slides[0].setAttribute("data-position", 1);
        window.slides[1].setAttribute("data-position", 2);
        window.slides[2].setAttribute("data-position", 3);

        togglerHandle();

        let left = document.querySelector(".arrow.arrow--left");
        left.addEventListener("click", moveLeft);
        let right = document.querySelector(".arrow.arrow--right");
        right.addEventListener("click", moveRight);

        window.addEventListener("resize", () => {
            moveResp(window.slides[0], "<");
            moveResp(window.slides[1], "<");
            moveResp(window.slides[2], "<");
            slideHeight();
            recalculateMoveDistance();
            togglerHandle();
        });
    }
}

function recalculateMoveDistance() {
    window.slide_size = window.slide_parent.offsetWidth / 3;
}

function togglerHandle() {
    if (document.body.clientWidth <= 768) {
        window.slides[0].setAttribute(
            "style",
            "transform: matrix(1,0,0,1," +
            -document.body.clientWidth +
            " ,0);opacity:0;"
        );
        window.slides[1].setAttribute(
            "style",
            "transform: matrix(1,0,0,1," + 0 + " ,0);opacity:1;"
        );
        window.slides[2].setAttribute(
            "style",
            "transform: matrix(1,0,0,1," +
            document.body.clientWidth +
            " ,0);opacity:0;"
        );
    } else {
        window.slides[0].setAttribute(
            "style",
            "-webkit-filter:blur(2px);filter:blur(2px);"
        );
        window.slides[2].setAttribute(
            "style",
            "-webkit-filter:blur(2px);filter:blur(2px);"
        );
        window.slides[1].setAttribute(
            "style",
            "transform: matrix(1.6,0,0,1.6," + 0 + " ,0);z-index:2; "
        );
    }
}

function slideHeight() {
    let height = 0;

    height = window.slides[2].querySelector("img").offsetHeight;
    if (document.body.clientWidth <= 768) {
        window.slide_parent.setAttribute("style", "height:" + height + "px");
    } else {
        window.slide_parent.setAttribute("style", "height:" + height * 1.6 + "px");
    }
}

function moveLeft() {
    setPosition(window.slides[0], "<");
    setPosition(window.slides[1], "<");
    setPosition(window.slides[2], "<");
    if (document.body.clientWidth <= 768) {
        moveResp(window.slides[0], "<");
        moveResp(window.slides[1], "<");
        moveResp(window.slides[2], "<");
    } else {
        moveFirst("<");
        moveSecond("<");
        moveThird("<");
    }
}

function moveRight() {
    setPosition(window.slides[0], ">");
    setPosition(window.slides[1], ">");
    setPosition(window.slides[2], ">");
    if (document.body.clientWidth <= 768) {
        moveResp(window.slides[0], ">");
        moveResp(window.slides[1], ">");
        moveResp(window.slides[2], ">");
    } else {
        moveFirst(">");
        moveSecond(">");
        moveThird(">");
    }
}

function setPosition(slide, direction) {
    let curr_pos = slide.dataset.position;
    if (direction == "<") {
        curr_pos++;
        if (curr_pos == 4) {
            curr_pos = 1;
        }
    }
    if (direction == ">") {
        curr_pos--;
        if (curr_pos == 0) {
            curr_pos = 3;
        }
    }
    slide.setAttribute("data-position", curr_pos);
}

function moveFirst(direction) {
    let z_index_1 = 0;
    let z_index_2 = 0;
    if (direction == ">") {
        z_index_1 = 2;
        z_index_2 = 1;
    } else if (direction == "<") {
        z_index_1 = 1;
        z_index_2 = 2;
    }
    switch (window.slides[0].dataset.position) {
        case "1": {
            window.slides[0].setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1,0 ,80);-ms-transform: matrix(1,0,0,1,0 ,80);transform: matrix(1,0,0,1,0 ,80);z-index:" +
                z_index_1 +
                "; -webkit-filter:blur(2px);filter:blur(2px);"
            );
            break;
        }
        case "2": {
            window.slides[0].setAttribute(
                "style",
                "-webkit-transform: matrix(1.6,0,0,1.6," +
                window.slide_size +
                " ,0);-ms-transform: matrix(1.6,0,0,1.6," +
                window.slide_size +
                " ,0);transform: matrix(1.6,0,0,1.6," +
                window.slide_size +
                " ,0);z-index:3;filter:blur(0px);"
            );
            break;
        }
        case "3": {
            window.slides[0].setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1," +
                window.slide_size * 2 +
                " ,80);-ms-transform: matrix(1,0,0,1," +
                window.slide_size * 2 +
                " ,80);transform: matrix(1,0,0,1," +
                window.slide_size * 2 +
                " ,80);z-index:" +
                z_index_2 +
                ";-webkit-filter:blur(2px);filter:blur(2px);"
            );
            break;
        }
    }
}

function moveSecond(direction) {
    let z_index_1 = 0;
    let z_index_2 = 0;
    if (direction == ">") {
        z_index_1 = 2;
        z_index_2 = 1;
    } else if (direction == "<") {
        z_index_1 = 1;
        z_index_2 = 2;
    }
    switch (window.slides[1].dataset.position) {
        case "1": {
            window.slides[1].setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1," +
                -window.slide_size +
                " ,80);-ms-transform: matrix(1,0,0,1," +
                -window.slide_size +
                " ,80);transform: matrix(1,0,0,1," +
                -window.slide_size +
                " ,80);z-index:" +
                z_index_1 +
                ";-webkit-filter:blur(2px);filter:blur(2px);"
            );
            break;
        }
        case "2": {
            window.slides[1].setAttribute(
                "style",
                "-webkit-transform: matrix(1.6,0,0,1.6,0,0);-ms-transform: matrix(1.6,0,0,1.6,0,0);transform: matrix(1.6,0,0,1.6,0,0);z-index:3;filter:blur(0px);"
            );
            break;
        }
        case "3": {
            window.slides[1].setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1," +
                window.slide_size +
                " ,80);-ms-transform: matrix(1,0,0,1," +
                window.slide_size +
                " ,80);transform: matrix(1,0,0,1," +
                window.slide_size +
                " ,80);z-index:" +
                z_index_2 +
                ";-webkit-filter:blur(2px);filter:blur(2px);"
            );
            break;
        }
    }
}

function moveThird(direction) {
    let z_index_1 = 0;
    let z_index_2 = 0;
    if (direction == ">") {
        z_index_1 = 2;
        z_index_2 = 1;
    } else if (direction == "<") {
        z_index_1 = 1;
        z_index_2 = 2;
    }
    switch (window.slides[2].dataset.position) {
        case "1": {
            window.slides[2].setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1," +
                -window.slide_size * 2 +
                " ,80);-ms-transform: matrix(1,0,0,1," +
                -window.slide_size * 2 +
                " ,80);transform: matrix(1,0,0,1," +
                -window.slide_size * 2 +
                " ,80);z-index:" +
                z_index_1 +
                ";-webkit-filter:blur(2px);filter:blur(2px);"
            );
            break;
        }
        case "2": {
            window.slides[2].setAttribute(
                "style",
                "-webkit-transform: matrix(1.6,0,0,1.6," +
                -window.slide_size +
                " ,0);-ms-transform: matrix(1.6,0,0,1.6," +
                -window.slide_size +
                " ,0);transform: matrix(1.6,0,0,1.6," +
                -window.slide_size +
                " ,0);z-index:3; filter:blur(0px);"
            );
            break;
        }
        case "3": {
            window.slides[2].setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1,0 ,80);-ms-transform: matrix(1,0,0,1,0 ,80);transform: matrix(1,0,0,1,0 ,80); z-index:" +
                z_index_2 +
                ";-webkit-filter:blur(2px);filter:blur(2px);"
            );
            break;
        }
    }
}

function moveResp(slide, direction) {
    switch (slide.dataset.position) {
        case "1": {
            slide.setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1," +
                -document.body.clientWidth +
                " ,0);-ms-transform: matrix(1,0,0,1," +
                -document.body.clientWidth +
                " ,0);transform: matrix(1,0,0,1," +
                -document.body.clientWidth +
                " ,0);opacity:0;"
            );
            break;
        }
        case "2": {
            slide.setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1,0,0);-ms-transform: matrix(1,0,0,1,0,0);transform: matrix(1,0,0,1,0,0);opacity:1;"
            );
            break;
        }
        case "3": {
            slide.setAttribute(
                "style",
                "-webkit-transform: matrix(1,0,0,1," +
                document.body.clientWidth +
                " ,0);-ms-transform: matrix(1,0,0,1," +
                document.body.clientWidth +
                " ,0);transform: matrix(1,0,0,1," +
                document.body.clientWidth +
                " ,0);opacity:0;"
            );
            break;
        }
    }
}

/*!
 * swiped-events.js - v@version@
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/swiped-events
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */
(function (window, document) {
    "use strict";

    // patch CustomEvent to allow constructor creation (IE/Chrome)
    if (typeof window.CustomEvent !== "function") {
        window.CustomEvent = function (event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined,
            };

            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(
                event,
                params.bubbles,
                params.cancelable,
                params.detail
            );
            return evt;
        };

        window.CustomEvent.prototype = window.Event.prototype;
    }

    document.addEventListener("touchstart", handleTouchStart, false);
    document.addEventListener("touchmove", handleTouchMove, false);
    document.addEventListener("touchend", handleTouchEnd, false);

    document.addEventListener("mousedown", handleTouchStart, false);
    document.addEventListener("mousemove", handleTouchMove, false);
    document.addEventListener("mouseup", handleTouchEnd, false);

    let xDown = null;
    let yDown = null;
    let xDiff = null;
    let yDiff = null;
    let timeDown = null;
    let startEl = null;

    function handleTouchEnd(e) {
        // if the user released on a different target, cancel!
        // if (startEl !== e.target) return;

        let swipeThreshold = parseInt(
            startEl.getAttribute("data-swipe-threshold") || "20",
            10
        ); // default 10px
        let swipeTimeout = parseInt(
            startEl.getAttribute("data-swipe-timeout") || "500",
            10
        ); // default 1000ms
        let timeDiff = Date.now() - timeDown;
        let eventType = "";

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            // most significant
            if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                if (xDiff > 0) {
                    eventType = "swiped-left";
                } else {
                    eventType = "swiped-right";
                }
            }
        } else {
            if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                if (yDiff > 0) {
                    eventType = "swiped-up";
                } else {
                    eventType = "swiped-down";
                }
            }
        }

        if (eventType !== "") {
            // fire event on the element that started the swipe
            startEl.dispatchEvent(
                new CustomEvent(eventType, {bubbles: true, cancelable: true})
            );

            // if (console && console.log) console.log(eventType + ' fired on ' + startEl.tagName);
        }

        // reset values
        xDown = null;
        yDown = null;
        timeDown = null;
    }

    function handleTouchStart(e) {
        // if the element has data-swipe-ignore="true" we stop listening for swipe events
        if (e.target.getAttribute("data-swipe-ignore") === "true") return;
        startEl = e.target;

        timeDown = Date.now();

        if (e.type === "touchstart") {
            xDown = e.touches[0].clientX;
        } else {
            xDown = e.clientX;
        }
        if (e.type === "touchstart") {
            yDown = e.touches[0].clientY;
        } else {
            yDown = e.clientY;
        }

        xDiff = 0;
        yDiff = 0;
    }

    function handleTouchMove(e) {
        if (!xDown || !yDown) return;
        let xUp;
        let yUp;

        if (e.type === "touchmove") {
            xUp = e.touches[0].clientX;
        } else {
            xUp = e.clientX;
        }
        if (e.type === "touchmove") {
            yUp = e.touches[0].clientY;
        } else {
            yUp = e.clientY;
        }

        xDiff = xDown - xUp;
        yDiff = yDown - yUp;
    }
})(window, document);
